import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

export default function SearchTextField({ value, onChange }) {
  return (
    <TextField
      fullWidth
      placeholder="Search"
      value={value}
      onChange={onChange}
      size="small"
      autoFocus
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
}
